import * as Interfaces from '#/CoreFrameInterfaces';

export default class PrincipalHelper {

    /**
     * Filtermodus: Default (Client)
     */
    public static readonly principalFilterDefaultClient: string = 'PRINCIPAL_SELECTOR_ONLY_CURRENT';

    /**
     * Filtermodus: Default (Server)
     */
    public static readonly principalFilterDefaultServer: string = 'Default';

    /**
     * Filtermodus: Nur Untermandanten (Client)
     */
    public static readonly principalFilterOnlySubClient: string = 'PRINCIPAL_SELECTOR_ONLY_SUB';

    /**
     * Filtermodus: Nur Untermandanten (Server)
     */
    public static readonly principalFilterOnlySubServer: string = 'OnlySubPrincipals';

    /**
     * Filtermodus: Aktueller Mandant und Untermandanten (Client)
     */
    public static readonly principalFilterCurrentAndSubClient: string = 'PRINCIPAL_SELECTOR_CURRENT_AND_SUB';

    /**
     * Filtermodus: Aktueller Mandant und Untermandanten (Server)
     */
    public static readonly principalFilterCurrentAndSubServer: string = 'WithSubPrincipals';

    /**
     * Filtermodus: Aktueller Mandant und Basismandanten (Client)
     */
    public static readonly principalFilterWithBaseClient: string = 'PRINCIPAL_SELECTOR_WITH_BASE';

    /**
     * Filtermodus: Aktueller Mandant und Basismandanten (Server)
     */
    public static readonly principalFilterWithBaseServer: string = 'WithBasePrincipals';

    /**
     * Filtermodus: Alle Mandanten (Client)
     */
    public static readonly principalFilterAllClient: string = 'PRINCIPAL_SELECTOR_ALL';

    /**
     * Filtermodus: Alle Mandanten (Server)
     */
    public static readonly principalFilterAllServer: string = 'WithAllPrincipals';

    constructor() {}

    private static principalFilterModesClientToServer = {
        [PrincipalHelper.principalFilterDefaultClient]: PrincipalHelper.principalFilterDefaultServer,
        [PrincipalHelper.principalFilterOnlySubClient]: PrincipalHelper.principalFilterOnlySubServer,
        [PrincipalHelper.principalFilterCurrentAndSubClient]: PrincipalHelper.principalFilterCurrentAndSubServer,
        [PrincipalHelper.principalFilterWithBaseClient]: PrincipalHelper.principalFilterWithBaseServer,
        [PrincipalHelper.principalFilterAllClient]: PrincipalHelper.principalFilterAllServer
    };

    /**
     * Liefert zu einem (Client-)Filter-Mode den Server-Filter-Mode
     * @param filterMode
     */
    public static getServerFilterMode(filterMode: string): string {
        let clientFilterMode = PrincipalHelper.principalFilterModesClientToServer[filterMode];

        // Fallback: Bereits ServerFilterMode
        if (!clientFilterMode && _.values(PrincipalHelper.principalFilterModesClientToServer).indexOf(filterMode) > 0) {
            clientFilterMode = filterMode;
        }

        return clientFilterMode;
    }

    /**
     * Liefert zu einem (Server-)Filter-Mode den Client-Filter-Mode
     * @param filterMode
     */
    public static getClientFilterMode(filterMode: string): string {
        for (let prop in PrincipalHelper.principalFilterModesClientToServer) {
            if (PrincipalHelper.principalFilterModesClientToServer.hasOwnProperty(prop)) {
                if (PrincipalHelper.principalFilterModesClientToServer[prop] === filterMode) {
                    return prop;
                }
                // Fallback: Bereits ClientFilterMode
                else if (prop === filterMode) {
                    return prop;
                }
            }
        }

        return null;
    }

    /**
     * Liefert zu (ListView-)Parametern den Client-Filter-Mode
     * @param listViewParameters
     */
    public static getClientFilterModeFromParameters(listViewParameters: Interfaces.PrincipalFilterParameters): string {
        if (listViewParameters.includeAllPrincipals) {
            return PrincipalHelper.principalFilterAllClient;
        } else if (listViewParameters.includeBasePrincipals) {
            return PrincipalHelper.principalFilterWithBaseClient;
        } else if (listViewParameters.includeSubPrincipals) {
            return PrincipalHelper.principalFilterCurrentAndSubClient;
        } else if (listViewParameters.onlySubPrincipals) {
            return PrincipalHelper.principalFilterOnlySubClient;
        } else {
            return PrincipalHelper.principalFilterDefaultClient;
        }
    }

    /**
     * Liefert zu (ListView-)Parametern den Server-Filter-Mode
     * @param listViewParameters
     */
    public static getServerFilterModeFromParameters(listViewParameters: Interfaces.PrincipalFilterParameters): string {
        const clientFilterMode = PrincipalHelper.getClientFilterModeFromParameters(listViewParameters);
        return PrincipalHelper.getServerFilterMode(clientFilterMode);
    }

    /**
     * Liefert alle verf�gbaren Filter-Modi des Clients
     */
    public static getAvailableClientFilterModes(): string[] {
        return [
            PrincipalHelper.principalFilterDefaultClient,
            PrincipalHelper.principalFilterAllClient,
            PrincipalHelper.principalFilterCurrentAndSubClient,
            PrincipalHelper.principalFilterOnlySubClient,
            PrincipalHelper.principalFilterWithBaseClient
        ];
    }

    /**
     * Liefert alle verf�gbaren Filter-Modi des Servers
     */
    public static getAvailableServerFilterModes(): string[] {
        return [
            PrincipalHelper.principalFilterDefaultServer,
            PrincipalHelper.principalFilterAllServer,
            PrincipalHelper.principalFilterCurrentAndSubServer,
            PrincipalHelper.principalFilterOnlySubServer,
            PrincipalHelper.principalFilterWithBaseServer
        ];
    }
}